import React from 'react';
import {Link} from 'react-router-dom';
import '../css/index.css';

export function Navigation() {

    return(
        <section className="Nav" >
            <div className="Nav-wrap">
                <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/events">Events</Link></li>
                    <li><Link to="/gallery">Gallery</Link></li>
                    <li><Link to="/members">Members</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                    <li><Link to="/spadrp">SPA DRP</Link></li>
                </ul>
            </div>

        </section>
    )
}